// getTableColumns.tsx
import * as XLSX from 'xlsx';

export const GetExcelExportWorkSheet = async (indicatorId: number,
    t: (key: string) => string, data: any,
    fromYearVal: number,
    toYearVal: number): Promise<XLSX.WorkSheet> => {

    const GetWorksheetForSkill_Development_Molsw = (t: (key: string) => string, data: any, fromYearVal: number, toYearVal: number) => {
        const ws_data = [
            // Header row for grouped columns
            [`(${fromYearVal} - ${toYearVal})`, '', '', `${fromYearVal}`, '', `${fromYearVal + 1}`, '', `${fromYearVal + 2}`, '', `${fromYearVal + 3}`, '', `${fromYearVal + 4}`, '', t("indicator.col.total1"), ''],
            [t("indicator.col.srno"), t("indicator.col.category"), t("indicator.col.subcategory"),
            t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"),
            t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"),
            t("indicator.col.total"), t("indicator.col.female")],
            // Data rows
            ...data.map((item: any) => [item['sr_no'], item['category'], item['subcategory'], item['1_total'], item['1_female'], item['2_total'], item['2_female'], item['3_total'], item['3_female'], item['4_total'], item['4_female'], item['5_total'], item['5_female'], item['tot_total'], item['tot_female']]),
        ];

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merging cells for grouping
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // Merge "Initial 3 cells"
            { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // Merge "First year"
            { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } }, // Merge "Second year"
            { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }, // Merge "Third year"
            { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } }, // Merge "Fourth year"
            { s: { r: 0, c: 11 }, e: { r: 0, c: 12 } }, // Merge "Fifth year"
            { s: { r: 0, c: 13 }, e: { r: 0, c: 14 } }, // Merge "Total Column"
        ];

        // Applying formula on Total Total column
        ws['N3'] = { t: 'n', f: 'D3+F3+H3+J3+L3' };
        ws['N4'] = { t: 'n', f: 'D4+F4+H4+J4+L4' };
        ws['N5'] = { t: 'n', f: 'D5+F5+H5+J5+L5' };
        ws['N6'] = { t: 'n', f: 'D6+F6+H6+J6+L6' };
        ws['N7'] = { t: 'n', f: 'D7+F7+H7+J7+L7' };
        ws['N8'] = { t: 'n', f: 'D8+F8+H8+J8+L8' };
        ws['N9'] = { t: 'n', f: 'D9+F9+H9+J9+L9' };
        ws['N10'] = { t: 'n', f: 'D10+F10+H10+J10+L10' };
        ws['N11'] = { t: 'n', f: 'D11+F11+H11+J11+L11' };
        ws['N12'] = { t: 'n', f: 'D12+F12+H12+J12+L12' };
        ws['N13'] = { t: 'n', f: 'D13+F13+H13+J13+L13' };
        ws['N14'] = { t: 'n', f: 'D14+F14+H14+J14+L14' };
        ws['N15'] = { t: 'n', f: 'D15+F15+H15+J15+L15' };
        ws['N16'] = { t: 'n', f: 'D16+F16+H16+J16+L16' };
        ws['N17'] = { t: 'n', f: 'D17+F17+H17+J17+L17' };
        ws['N18'] = { t: 'n', f: 'D18+F18+H18+J18+L18' };
        ws['N19'] = { t: 'n', f: 'D19+F19+H19+J19+L19' };
        ws['N20'] = { t: 'n', f: 'D20+F20+H20+J20+L20' };
        ws['N21'] = { t: 'n', f: 'D21+F21+H21+J21+L21' };
        ws['N22'] = { t: 'n', f: 'D22+F22+H22+J22+L22' };
        ws['N23'] = { t: 'n', f: 'D23+F23+H23+J23+L23' };
        ws['N24'] = { t: 'n', f: 'D24+F24+H24+J24+L24' };
        ws['N25'] = { t: 'n', f: 'D25+F25+H25+J25+L25' };
        ws['N26'] = { t: 'n', f: 'D26+F26+H26+J26+L26' };

        // Applying formula on Total Female column
        ws['O3'] = { t: 'n', f: 'E3+G3+I3+K3+M3' };
        ws['O4'] = { t: 'n', f: 'E4+G4+I4+K4+M4' };
        ws['O5'] = { t: 'n', f: 'E5+G5+I5+K5+M5' };
        ws['O6'] = { t: 'n', f: 'E6+G6+I6+K6+M6' };
        ws['O7'] = { t: 'n', f: 'E7+G7+I7+K7+M7' };
        ws['O8'] = { t: 'n', f: 'E8+G8+I8+K8+M8' };
        ws['O9'] = { t: 'n', f: 'E9+G9+I9+K9+M9' };
        ws['O10'] = { t: 'n', f: 'E10+G10+I10+K10+M10' };
        ws['O11'] = { t: 'n', f: 'E11+G11+I11+K11+M11' };
        ws['O12'] = { t: 'n', f: 'E12+G12+I12+K12+M12' };
        ws['O13'] = { t: 'n', f: 'E13+G13+I13+K13+M13' };
        ws['O14'] = { t: 'n', f: 'E14+G14+I14+K14+M14' };
        ws['O15'] = { t: 'n', f: 'E15+G15+I15+K15+M15' };
        ws['O16'] = { t: 'n', f: 'E16+G16+I16+K16+M16' };
        ws['O17'] = { t: 'n', f: 'E17+G17+I17+K17+M17' };
        ws['O18'] = { t: 'n', f: 'E18+G18+I18+K18+M18' };
        ws['O19'] = { t: 'n', f: 'E19+G19+I19+K19+M19' };
        ws['O20'] = { t: 'n', f: 'E20+G20+I20+K20+M20' };
        ws['O21'] = { t: 'n', f: 'E21+G21+I21+K21+M21' };
        ws['O22'] = { t: 'n', f: 'E22+G22+I22+K22+M22' };
        ws['O23'] = { t: 'n', f: 'E23+G23+I23+K23+M23' };
        ws['O24'] = { t: 'n', f: 'E24+G24+I24+K24+M24' };
        ws['O25'] = { t: 'n', f: 'E25+G25+I25+K25+M25' };
        ws['O26'] = { t: 'n', f: 'E26+G26+I26+K26+M26' };

        return ws;

    }

    const GetWorksheetForEntrance_Exit_Data_Foreign_Nationals_MoPS = (t: (key: string) => string, data: any) => {
        const ws_data = [
            // Header row for grouped columns
            [`${t('tabletitle.foreign_nationalone')} ${fromYearVal} - ${toYearVal}`, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            [t("indicator.col.year"), t("indicator.col.male"), '', t("indicator.col.female"), '', t("indicator.col.children"), '', t("indicator.col.total"), '', t("indicator.col.diplomatic"), '', t("indicator.col.official"), '', t("indicator.col.visit"), '', t("indicator.col.business"), '', t("indicator.col.tourism"), '', t("indicator.col.transit"), ''],
            ['', t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit")],
            // Data rows
            ...data.map((item: any) => [item.year, item.male_ent, item.male_exit, item.female_ent, item.female_exit, item.children_ent, item.children_exit, item.total_ent, item.total_exit, item.diplomatic_ent, item.diplomatic_exit, item.official_ent, item.official_exit, item.visit_ent, item.visit_exit, item.business_ent, item.business_exit, item.tourism_ent, item.tourism_exit, item.transit_ent, item.transit_exit]),
        ];

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merging cells for grouping
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 20 } }, // Merge "First Row"
            { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } }, // Merge "Year"
            { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } }, // Merge "Male Entry/Exit"
            { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, // Merge "Female Entry/Exit"
            { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } }, // Merge "Children Entry/Exit"
            { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // Merge "Total Entry/Exit"
            { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // Merge "Diplomatic Entry/Exit"
            { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } }, // Merge "Official Entry/Exit"
            { s: { r: 1, c: 13 }, e: { r: 1, c: 14 } }, // Merge "Visit Entry/Exit"
            { s: { r: 1, c: 15 }, e: { r: 1, c: 16 } }, // Merge "Business Entry/Exit"
            { s: { r: 1, c: 17 }, e: { r: 1, c: 18 } }, // Merge "Tourism Entry/Exit"
            { s: { r: 1, c: 19 }, e: { r: 1, c: 20 } } // Merge "Transit Entry/Exit"
        ];

        return ws;
    }

    const GetWorksheetForFamily_Registration_MoHA = (t: (key: string) => string, data: any) => {
        const ws_data = [
            // Header rows
            [
                '', '', t("indicator.col.birth.registration.a.year"), '', t("indicator.col.birth.registration.under5.year"), '',
                t("indicator.col.birth.registration.upper5.year"), '', t("indicator.col.marriage.registration"), '', '', '', t("indicator.col.divorce.registration"), '', '', '',
                t("indicator.col.register.changeofname"), '', t("indicator.col.register.changeofsurname"), '', t("indicator.col.register.changeofnationality"), '', '', '', '', '', '', '', '', '', t("indicator.col.move-in.registration"), '', '', '', '', '', '', '', t("indicator.col.move-out.registration"), '', '', '', '', '', '', '', t("indicator.col.death.reg.lower5"), '', t("indicator.col.death.reg.over5"), '',
            ],
            [
                '', '', '', '', '', '', '', '', t("lao.lao"), t("lao.foreigner"), t("lao.alien"), t("lao.stateless.person"), t("lao.lao"), t("lao.foreigner"), t("lao.alien"), t("lao.stateless.person"), '', '', '', '', t("indicator.col.total"), '', t("indicator.col.lao.citizenship.granting"), '', t("indicator.col.lao.citizenship.restoration"), '', t("indicator.col.lao.citizenship.revocation"), '', t("indicator.col.lao.citizenship.abandonment"), '', t("indicator.col.total"), '', t("indicator.col.village"), '', t("indicator.col.district"), '', t("indicator.col.province"), '', t("indicator.col.total"), '', t("indicator.col.village"), '', t("indicator.col.district"), '', t("indicator.col.province"), '', '', '', '', ''
            ],
            [
                t("indicator.col.province.code"), t("indicator.col.province.name"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female")
            ],
            // [t("indicator.col.province.code"), t("indicator.col.province.name"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value")],
            // Data rows
            ...data.map((item: any) => [
                item.province_code,
                item.province_name,
                item.birth_reg_within_a_year_total,
                item.birth_reg_within_a_year_female,
                item.birth_reg_under_5_years_age_total,
                item.birth_reg_under_5_years_age_female,
                item.birth_reg_upper_5_years_age_total,
                item.birth_reg_upper_5_years_of_age_female,
                item.marriage_reg_lao_lao,
                item.marriage_reg_lao_foreigner,
                item.marriage_reg_lao_alien,
                item.marriage_reg_lao_stateless_person,
                item.divorce_reg_lao_lao,
                item.divorce_reg_lao_foreigner,
                item.divorce_reg_lao_Alien,
                item.divorce_reg_lao_stateless_person,
                item.reg_change_of_name_total,
                item.reg_change_of_name_female,
                item.reg_change_of_surname_total,
                item.reg_change_of_surname_female,
                item.reg_change_of_national_total_total,
                item.reg_change_of_national_total_female,
                item.reg_change_of_national_lao_citizen_granting_total,
                item.reg_change_of_national_lao_citizen_granting_female,
                item.reg_change_of_national_lao_citizen_restoration_total,
                item.reg_change_of_national_lao_citizen_restoration_female,
                item.reg_change_of_national_lao_citizen_revocation_total,
                item.reg_change_of_national_lao_citizen_revocation_female,
                item.reg_change_of_national_lao_citizen_abandonment_total,
                item.reg_change_of_national_lao_citizen_abandonment_female,
                item.move_in_reg_total_total,
                item.move_in_reg_total_female,
                item.move_in_reg_village_village_total,
                item.move_in_reg_village_village_female,
                item.move_in_reg_district_district_total,
                item.move_in_reg_district_district_female,
                item.move_in_reg_province_province_total,
                item.move_in_reg_province_province_female,
                item.move_out_reg_total_total,
                item.move_out_reg_total_female,
                item.move_out_reg_village_village_total,
                item.move_out_reg_village_village_female,
                item.move_out_reg_district_district_total,
                item.move_out_reg_district_district_female,
                item.move_out_reg_province_province_total,
                item.move_out_reg_province_province_female,
                item.death_reg_lower_5_years_total,
                item.death_reg_lower_5_years_female,
                item.death_reg_over_5_years_total,
                item.death_reg_over_5_years_female]),
        ];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        const ws_merges = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 1 } }];
        ws['!merges'] = ws_merges;
        return ws;
    }


    const GetWorksheetForTotal_Statistics_Molsw = (t: (key: string) => string, data: any, fromYearVal: number, toYearVal: number) => {

        const ws_data = [
            // Header row for grouped columns
            ['', '', '', `${fromYearVal}-${fromYearVal + 1}`, '', `${fromYearVal + 1}-${fromYearVal + 2}`, '', `${fromYearVal + 2}-${fromYearVal + 3}`, '', `${fromYearVal + 3}-${fromYearVal + 4}`, '', `${fromYearVal + 4}-${fromYearVal + 5}`, '', t("indicator.col.total1"), ''],
            [t("indicator.col.srno"), t("indicator.col.category"), t("indicator.col.subcategory"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female")],
            // Data rows
            ...data.map((item: any) => [item['sr_no'], item['category'], item['subcategory'], item['1_total'], item['1_female'], item['2_total'], item['2_female'], item['3_total'], item['3_female'], item['4_total'], item['4_female'], item['5_total'], item['5_female'], item['tot_total'], item['tot_female']]),
        ];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        // Merging cells for grouping
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // Merge "Initial 3 cells"
            { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // Merge "First year"
            { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } }, // Merge "Second year"
            { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }, // Merge "Third year"
            { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } }, // Merge "Fourth year"
            { s: { r: 0, c: 11 }, e: { r: 0, c: 12 } }, // Merge "Fifth year"
            { s: { r: 0, c: 13 }, e: { r: 0, c: 14 } }, // Merge "Total Column"
        ];

        // Applying formula on Total Total column
        ws['N3'] = { t: 'n', f: 'D3+F3+H3+J3+L3' };
        ws['N4'] = { t: 'n', f: 'D4+F4+H4+J4+L4' };
        ws['N5'] = { t: 'n', f: 'D5+F5+H5+J5+L5' };
        ws['N6'] = { t: 'n', f: 'D6+F6+H6+J6+L6' };
        ws['N7'] = { t: 'n', f: 'D7+F7+H7+J7+L7' };
        ws['N8'] = { t: 'n', f: 'D8+F8+H8+J8+L8' };
        ws['N9'] = { t: 'n', f: 'D9+F9+H9+J9+L9' };
        ws['N10'] = { t: 'n', f: 'D10+F10+H10+J10+L10' };
        ws['N11'] = { t: 'n', f: 'D11+F11+H11+J11+L11' };
        ws['N12'] = { t: 'n', f: 'D12+F12+H12+J12+L12' };
        ws['N13'] = { t: 'n', f: 'D13+F13+H13+J13+L13' };
        ws['N14'] = { t: 'n', f: 'D14+F14+H14+J14+L14' };
        ws['N15'] = { t: 'n', f: 'D15+F15+H15+J15+L15' };
        ws['N16'] = { t: 'n', f: 'D16+F16+H16+J16+L16' };
        ws['N17'] = { t: 'n', f: 'D17+F17+H17+J17+L17' };
        ws['N18'] = { t: 'n', f: 'D18+F18+H18+J18+L18' };
        ws['N19'] = { t: 'n', f: 'D19+F19+H19+J19+L19' };
        ws['N20'] = { t: 'n', f: 'D20+F20+H20+J20+L20' };
        ws['N21'] = { t: 'n', f: 'D21+F21+H21+J21+L21' };
        ws['N22'] = { t: 'n', f: 'D22+F22+H22+J22+L22' };
        ws['N23'] = { t: 'n', f: 'D23+F23+H23+J23+L23' };
        ws['N24'] = { t: 'n', f: 'D24+F24+H24+J24+L24' };
        ws['N25'] = { t: 'n', f: 'D25+F25+H25+J25+L25' };
        ws['N26'] = { t: 'n', f: 'D26+F26+H26+J26+L26' };
        ws['N27'] = { t: 'n', f: 'D27+F27+H27+J27+L27' };
        ws['N28'] = { t: 'n', f: 'D28+F28+H28+J28+L28' };
        ws['N29'] = { t: 'n', f: 'D29+F29+H29+J29+L29' };
        ws['N30'] = { t: 'n', f: 'D30+F30+H30+J30+L30' };
        ws['N31'] = { t: 'n', f: 'D31+F31+H31+J31+L31' };
        ws['N32'] = { t: 'n', f: 'D32+F32+H32+J32+L32' };
        ws['N33'] = { t: 'n', f: 'D33+F33+H33+J33+L33' };
        ws['N34'] = { t: 'n', f: 'D34+F34+H34+J34+L34' };
        ws['N35'] = { t: 'n', f: 'D35+F35+H35+J35+L35' };
        ws['N36'] = { t: 'n', f: 'D36+F36+H36+J36+L36' };
        ws['N37'] = { t: 'n', f: 'D37+F37+H37+J37+L37' };
        ws['N38'] = { t: 'n', f: 'D38+F38+H38+J38+L38' };
        ws['N39'] = { t: 'n', f: 'D39+F39+H39+J39+L39' };
        ws['N40'] = { t: 'n', f: 'D40+F40+H40+J40+L40' };
        ws['N41'] = { t: 'n', f: 'D41+F41+H41+J41+L41' };
        ws['N42'] = { t: 'n', f: 'D42+F42+H42+J42+L42' };

        // Applying formula on Total Female column
        ws['O3'] = { t: 'n', f: 'E3+G3+I3+K3+M3' };
        ws['O4'] = { t: 'n', f: 'E4+G4+I4+K4+M4' };
        ws['O5'] = { t: 'n', f: 'E5+G5+I5+K5+M5' };
        ws['O6'] = { t: 'n', f: 'E6+G6+I6+K6+M6' };
        ws['O7'] = { t: 'n', f: 'E7+G7+I7+K7+M7' };
        ws['O8'] = { t: 'n', f: 'E8+G8+I8+K8+M8' };
        ws['O9'] = { t: 'n', f: 'E9+G9+I9+K9+M9' };
        ws['O10'] = { t: 'n', f: 'E10+G10+I10+K10+M10' };
        ws['O11'] = { t: 'n', f: 'E11+G11+I11+K11+M11' };
        ws['O12'] = { t: 'n', f: 'E12+G12+I12+K12+M12' };
        ws['O13'] = { t: 'n', f: 'E13+G13+I13+K13+M13' };
        ws['O14'] = { t: 'n', f: 'E14+G14+I14+K14+M14' };
        ws['O15'] = { t: 'n', f: 'E15+G15+I15+K15+M15' };
        ws['O16'] = { t: 'n', f: 'E16+G16+I16+K16+M16' };
        ws['O17'] = { t: 'n', f: 'E17+G17+I17+K17+M17' };
        ws['O18'] = { t: 'n', f: 'E18+G18+I18+K18+M18' };
        ws['O19'] = { t: 'n', f: 'E19+G19+I19+K19+M19' };
        ws['O20'] = { t: 'n', f: 'E20+G20+I20+K20+M20' };
        ws['O21'] = { t: 'n', f: 'E21+G21+I21+K21+M21' };
        ws['O22'] = { t: 'n', f: 'E22+G22+I22+K22+M22' };
        ws['O23'] = { t: 'n', f: 'E23+G23+I23+K23+M23' };
        ws['O24'] = { t: 'n', f: 'E24+G24+I24+K24+M24' };
        ws['O25'] = { t: 'n', f: 'E25+G25+I25+K25+M25' };
        ws['O26'] = { t: 'n', f: 'E26+G26+I26+K26+M26' };
        ws['O27'] = { t: 'n', f: 'E27+G27+I27+K27+M27' };
        ws['O28'] = { t: 'n', f: 'E28+G28+I28+K28+M28' };
        ws['O29'] = { t: 'n', f: 'E29+G29+I29+K29+M29' };
        ws['O30'] = { t: 'n', f: 'E30+G30+I30+K30+M30' };
        ws['O31'] = { t: 'n', f: 'E31+G31+I31+K31+M31' };
        ws['O32'] = { t: 'n', f: 'E32+G32+I32+K32+M32' };
        ws['O33'] = { t: 'n', f: 'E33+G33+I33+K33+M33' };
        ws['O34'] = { t: 'n', f: 'E34+G34+I34+K34+M34' };
        ws['O35'] = { t: 'n', f: 'E35+G35+I35+K35+M35' };
        ws['O36'] = { t: 'n', f: 'E36+G36+I36+K36+M36' };
        ws['O37'] = { t: 'n', f: 'E37+G37+I37+K37+M37' };
        ws['O38'] = { t: 'n', f: 'E38+G38+I38+K38+M38' };
        ws['O39'] = { t: 'n', f: 'E39+G39+I39+K39+M39' };
        ws['O40'] = { t: 'n', f: 'E40+G40+I40+K40+M40' };
        ws['O41'] = { t: 'n', f: 'E41+G41+I41+K41+M41' };
        ws['O42'] = { t: 'n', f: 'E42+G42+I42+K42+M42' };

        return ws;

    }

    const GetWorksheetForEntrance_Exit_Data_Lao_Nationals_MoPS = (t: (key: string) => string, data: any) => {
        const ws_data = [
            // Header row for grouped columns
            [`${t('tabletitle.lao.nationalone')} ${fromYearVal} - ${toYearVal}`, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            [t("indicator.col.year"), t("indicator.col.male"), '', t("indicator.col.female"), '', t("indicator.col.children"), '', t("indicator.col.total"), '', t("indicator.col.diplomatic"), '', t("indicator.col.official"), '', t("indicator.col.visit"), '', t("indicator.col.business"), '', t("indicator.col.tourism"), '', t("indicator.col.transit"), ''],
            ['', t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit"), t("indicator.col.ent"), t("indicator.col.exit")],
            // Data rows
            ...data.map((item: any) => [item.year, item.male_ent, item.male_exit, item.female_ent, item.female_exit, item.children_ent, item.children_exit, item.total_ent, item.total_exit, item.diplomatic_ent, item.diplomatic_exit, item.official_ent, item.official_exit, item.visit_ent, item.visit_exit, item.business_ent, item.business_exit, item.tourism_ent, item.tourism_exit, item.transit_ent, item.transit_exit]),
        ];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merging cells for grouping
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 20 } }, // Merge "First Row"
            { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } }, // Merge "Year"
            { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } }, // Merge "Male Entry/Exit"
            { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, // Merge "Female Entry/Exit"
            { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } }, // Merge "Children Entry/Exit"
            { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // Merge "Total Entry/Exit"
            { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // Merge "Diplomatic Entry/Exit"
            { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } }, // Merge "Official Entry/Exit"
            { s: { r: 1, c: 13 }, e: { r: 1, c: 14 } }, // Merge "Visit Entry/Exit"
            { s: { r: 1, c: 15 }, e: { r: 1, c: 16 } }, // Merge "Business Entry/Exit"
            { s: { r: 1, c: 17 }, e: { r: 1, c: 18 } }, // Merge "Tourism Entry/Exit"
            { s: { r: 1, c: 19 }, e: { r: 1, c: 20 } } // Merge "Transit Entry/Exit"
        ];

        return ws;

    }

    const GetWorksheetForStatistics_of_Lao_Population_MoHA = (t: (key: string) => string, data: any, fromYearVal: number, toYearVal: number) => {
        const ws_data = [
            // Header rows
            ['', '', t("indicator.col.no.of.district"), t("indicator.col.no.of.village"), t("indicator.col.no.of.unit"), t("indicator.col.no.of.family"), `${t("indicator.col.no.of.laospopulation")}`, '', t("indicator.col.birth.notification"), '', t("indicator.col.married.proposal.under18"), '', '', '', t("indicator.col.married.proposal.upper18"), '', '', '', t("indicator.col.uncontested.divorce"), '', '', '', t("indicator.col.register.changeofname"), '', t("indicator.col.register.changeofsurname"), '', t("indicator.col.move-in.request"), '', '', '', '', '', '', '', t("indicator.col.move-out.request"), '', '', '', '', '', '', '', t("indicator.col.death.notification"), '', '', '', '', '', t("indicator.col.total.lao.population"), ''],
            ['', '', '', '', '', '', '', '', '', '',
                t("lao.lao"), t("lao.foreigner"), t("lao.alien"), t("lao.stateless.person"),
                t("lao.lao"), t("lao.foreigner"), t("lao.alien"), t("lao.stateless.person"),
                t("lao.lao"), t("lao.foreigner"), t("lao.alien"), t("lao.stateless.person"),
                '', '', '', '',
                t("indicator.col.total"), '', t("indicator.col.village"), '', t("indicator.col.district"), '', t("indicator.col.province"), '',
                t("indicator.col.total"), '', t("indicator.col.village"), '', t("indicator.col.district"), '', t("indicator.col.province"), '',
                t("indicator.col.total"), '', t("indicator.col.lower.5.years"), '', t("indicator.col.over.5.years"), '', '', ''],
            [t("indicator.col.province.code"), t("indicator.col.province.name"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female"), t("indicator.col.total"), t("indicator.col.female")],
            // [t("indicator.col.province.code"), t("indicator.col.province.name"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value"), t("lao.value")],

            // Data rows
            ...data.map((item: any) => [
                item.province_code,
                item.province_name,
                item.num_of_district_total,
                item.num_of_village_total,
                item.num_of_unit_total,
                item.num_of_family_total,
                item.num_laos_population_in_2022_total,
                item.num_laos_population_in_2022_female,
                item.Birth_notification_total,
                item.Birth_notification_female,
                item.married_proposal_under_18_years_old_lao_lao,
                item.married_proposal_under_18_years_lao_foreigner,
                item.married_proposal_under_18_years_lao_alien,
                item.married_proposal_under_18_year_lao_stateless_person,
                item.married_proposal_upper_18_years_old_lao_lao,
                item.married_proposal_upper_18_years_old_lao_foreigner,
                item.married_proposal_upper_18_years_old_lao_alln,
                item.married_proposal_upper_18_years_old_lao_stateless_person,
                item.uncontested_divorce_Lao_Lao,
                item.uncontested_divorce_Lao_Foreigner,
                item.uncontested_divorce_Lao_Alien,
                item.uncontested_divorce_Lao_Stateless_person,
                item.reg_change_name_total,
                item.reg_change_name_female,
                item.reg_change_surname_total,
                item.reg_change_surname_female,
                item.move_in_request_total_total,
                item.move_in_request_total_female,

                item.move_in_request_village_village_total,
                item.move_in_request_village_village_female,

                item.move_in_request_district_district_total,
                item.move_in_request_district_district_female,

                item.move_in_request_Province_Province_total,
                item.move_in_request_Province_Province_female,

                item.move_out_request_total_total,
                item.move_out_request_total_female,

                item.move_out_request_village_village_total,
                item.move_out_request_village_village_female,

                item.move_out_request_district_district_total,
                item.move_out_request_district_district_female,

                item.move_out_request_Province_Province_total,
                item.move_out_request_Province_Province_female,

                item.death_notification_total_total,
                item.death_notification_total_female,

                item.death_notification_Lower_5_years_total,
                item.death_notification_Lower_5_years_female,

                item.death_notification_Over_5_years_total,
                item.death_notification_Over_5_years_female,

                item.total_lao_population_total,
                item.total_lao_population_female,
            ]),
        ];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        const ws_merges = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 1 } }];
        ws['!merges'] = ws_merges;

        return ws;
    }

    switch (indicatorId) {
        case 9:
            return GetWorksheetForSkill_Development_Molsw(t, data, fromYearVal, toYearVal);
        case 11:
            return GetWorksheetForEntrance_Exit_Data_Foreign_Nationals_MoPS(t, data);
        case 13:
            return GetWorksheetForFamily_Registration_MoHA(t, data);
        case 14:
            return GetWorksheetForTotal_Statistics_Molsw(t, data, fromYearVal, toYearVal);
        case 15:
            return GetWorksheetForEntrance_Exit_Data_Lao_Nationals_MoPS(t, data);
        case 16:
            return GetWorksheetForStatistics_of_Lao_Population_MoHA(t, data, fromYearVal, toYearVal);
        default:
            return GetWorksheetForEntrance_Exit_Data_Foreign_Nationals_MoPS(t, data);
    }
}